import React from 'react';
import { 
  Header,
  Footer,
} from '../components';

/**
 * About页面
 */
export default class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: 'Loading...'
    };
  }

  componentDidMount() {
    // 修改页面title
    document.title = "关于我们";
  }

  render() {
    return (
      <div>
        <Header />
        <div className="container">
           <form> 
           <fieldset> 
           <legend>Legend</legend> 
           <label>Label name</label> 
           <input type="text" id="name" placeholder="Type something..." /> 
           <span className="help-block">Example block-level help text here.</span> 
           <label className="checkbox"> 
           <input type="checkbox" id="checkbox" /> Check me out </label> 
            <input type="text" className="input-medium search-query" /> 
           <button type="submit" className="btn">Submit</button> 
           </fieldset> 
           </form>
            <form className="form-search"> 
            <input className="input-block-level" type="text" placeholder=".input-block-level" />
            <button type="submit" className="btn">Search</button> 
            </form>
        </div>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/About.js